import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CustomPagerComponent } from './custom-pager/custom-pager.component';
import { SideBarComponent } from './side-bar/side-bar.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { AppRoutingModule } from '../app-routing.module';


@NgModule({
  declarations: [
    SideBarComponent,
    TopBarComponent,
    CustomPagerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    AppRoutingModule
  ],
  exports: [
    SideBarComponent,
    TopBarComponent,
    CustomPagerComponent,
  ],
})
export class LayoutModule { }
